const ERROR_CONSTANTS = {
  NO_CREDIT_LINE_FOUND: 'NO_CREDIT_LINE_FOUND',
  NOT_ENOUGH_CREDIT_LINE_BALANCE: 'NOT_ENOUGH_CREDIT_LINE_BALANCE',
};

module.exports = {
    ERROR_CONSTANTS
}